import React, {Component} from 'react';

export default class Popup extends Component {
	constructor(props) {
		super(props);
		this.state = { active: false };
		this._handleKeyDown = this._handleKeyDown.bind(this);
	}

	componentWillMount() {
		document.addEventListener("keydown", this._handleKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this._handleKeyDown);
	}

	componentDidMount() {
		setTimeout(() => this.setState({ active: true }), 0);
	}

	_handleKeyDown(e) {
		if (e.keyCode == 27)
			this._closePopup();
	}

	_closePopup() {
		this.setState({ active: false });
		if (this.props.onClose) {
			setTimeout(this.props.onClose, 300);
		}
	}

	get _hasTitle() {
		return this.props.title || this.props.subtitle;
	}

	render() {
		return (
			<section id={this.props.id} className={this.state.active ? "generic-popup-container active" : "generic-popup-container"}>
				<section className="mask" onClick={() => {this._closePopup()}}></section>

				<section className="generic-popup">
					<section className="header">

					{ !this.props.titleElement &&
						<section>
							<button className="btn-close" onClick={() => {this._closePopup()}}><img alt="Fechar" src={require('../img/icon-btn-close.svg')}/></button>

							<div className="center-content">
								<h3>{ this.props.title }</h3>
								{this.props.subtitle && <span>{this.props.subtitle}</span>}
							</div>
							{this.props.menu}
						</section>
					}

					{ this.props.titleElement }

					</section>

					{this.props.children}
				</section>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Popup.js